var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-card',{attrs:{"color":_vm.color,"id":_vm.id}},[_c('img',{attrs:{"src":_vm.image}}),_c('ion-card-header',[_c('ion-card-title',[_vm._v(_vm._s(this.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }